import { Box, Container, Heading, VStack, Flex } from "@chakra-ui/react";
import BenefitCard from "./BenefitCard";

const FeatureCard = ({
  title = "Key Features",
  features = [],
  backgroundImage = "/png/share-your-idea.png",
}) => {
  return (
    <Box
      maxW="12xl"
      mx="auto"
      bgImage={`url('${backgroundImage}')`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      py={16}
      px={6}
      textAlign="center"
      position="relative"
      overflow="hidden"
      borderRadius="lg"
      my={8}
    >
      <Container maxW="12xl">
        <VStack spacing={12}>
          <Heading
            fontSize={{ base: "3xl", md: "4xl" }}
            fontWeight="bold"
            color="white"
            textAlign="center"
          >
            {title}
          </Heading>

          <Flex
            wrap="wrap"
            justify="center"
            gap={6}
            w="full"
            maxW="5xl"
            mx="auto"
          >
            {features.map((feature) => (
              <Box
                key={feature.id}
                flex="1 1 300px" 
                maxW="350px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <BenefitCard benefit={feature} h="100%" />
              </Box>
            ))}
          </Flex>
        </VStack>
      </Container>
    </Box>
  );
};

export default FeatureCard;
